/**
 * Which pages are creative tool pages, for the mobile "open the app" sheet
 * (components/MobileAppPrompt.tsx). Kept free of React so the rule is
 * unit-testable on its own.
 *
 * The mobile app has no creative tools: its tabs are Home, Video, Music and
 * Library (mobile/app/(tabs)), no screen opens an image, video or audio tool,
 * and it never calls the creativeTools API. A visitor who searched for a
 * background remover or an image upscaler and tapped "Open" landed in an app
 * without it.
 */
import {
  creativeSeoKeyForPath,
  isExcludedCreativeToolPath,
} from "@shared/creativeToolsSeoPaths";

/**
 * True for the creative hub, the three category pages, and every tool and
 * preset page, at /creative-tools/<slug> or at its own root URL
 * (/ai-video-ad-generator). Takes the path without its language prefix
 * (useLanguageRouter's pathWithoutLang); a query string or hash is ignored.
 */
export function isCreativeToolPage(pathWithoutLang: string): boolean {
  const path = pathWithoutLang.split(/[?#]/)[0] || "/";
  // The indexable pages: hub, categories, tools and presets.
  if (creativeSeoKeyForPath(path) !== null) return true;
  // The tools kept out of the index (the face swaps) are web-only all the same.
  return isExcludedCreativeToolPath(path);
}
